module.exports = __webpack_public_path__ + "img/delete.f88ad30b.svg";